import React from 'react';
import { Modal, Button, Table, Row, Col, Card } from 'react-bootstrap';

const SummarySection = ({ title, data }) => {
    if (!data || Object.keys(data).length === 0) {
        return null;
    }

    return (
        <Card className="mb-3">
            <Card.Header as="h6">{title}</Card.Header>
            <Table striped bordered hover responsive size="sm" className="mb-0">
                <thead>
                    <tr>
                        <th>항목</th>
                        <th className="text-end">건수</th>
                        <th className="text-end">금액 (원)</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.entries(data).map(([key, value]) => (
                        <tr key={key}>
                            <td>{key}</td>
                            <td className="text-end">{(value.count ?? 0).toLocaleString()}</td>
                            {/* unpriced 는 "스냅샷에 줄별 금액이 없는 건수" 다(server/utils/priceBreakdown.js).
                                그 건들은 금액에 0 을 더하지 않으므로, 적어주지 않으면 합계가
                                그냥 적게 보인다 — 왜 적은지를 같이 말해야 한다. */}
                            <td className="text-end">
                                {(value.total ?? 0).toLocaleString()}
                                {value.unpriced > 0 && (
                                    <div className="summary-unpriced">
                                        {value.unpriced.toLocaleString()}건 금액 미기록
                                    </div>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </Card>
    );
};


const DailySummaryModal = ({ show, onHide, summaryData, date }) => {
    if (!summaryData) {
        return (
            <Modal show={show} onHide={onHide} centered>
                <Modal.Header closeButton>
                    <Modal.Title>일일 정산 요약</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>데이터를 불러오는 중입니다...</p>
                </Modal.Body>
            </Modal>
        );
    }

    const formattedDate = new Date(date).toLocaleDateString('ko-KR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
    });

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>일일 정산 요약 - {formattedDate}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Card className="text-center mb-4 bg-light">
                    <Card.Body>
                        <Row>
                            <Col>
                                <p className="mb-0 text-muted">총 매출</p>
                                <h4>{(summaryData.totalRevenue ?? 0).toLocaleString()} 원</h4>
                            </Col>
                            <Col>
                                <p className="mb-0 text-muted">총 서비스</p>
                                <h4>{(summaryData.totalServices ?? 0).toLocaleString()} 건</h4>
                            </Col>
                             <Col>
                                <p className="mb-0 text-muted">신규 방문</p>
                                <h4>{(summaryData.newVisits ?? 0).toLocaleString()} 건</h4>
                            </Col>
                             <Col>
                                <p className="mb-0 text-muted">재방문</p>
                                <h4>{(summaryData.returningVisits ?? 0).toLocaleString()} 건</h4>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                <Row>
                    <Col md={6}>
                        <SummarySection title="결제 수단별" data={summaryData.byPaymentMethod} />
                        <SummarySection title="직원별" data={summaryData.byStaff} />
                    </Col>
                    <Col md={6}>
                        <SummarySection title="메뉴별" data={summaryData.byMenu} />
                        <SummarySection title="옵션별" data={summaryData.byOption} />
                    </Col>
                </Row>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    닫기
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DailySummaryModal;
